import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { deletetype, gettype } from '../redux-toolkit/Slice/typeSlice';
import { BASE_URL, DELETE_type, GET_type } from '../redux-toolkit/ApiEndpoint';


import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const Producttype = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleAddtypeClick = () => {
        navigate('/add', {
            state: { title: "Type", label: 'Product Type Name', placeholder: 'Enter Type name' },
        });
    };

    const handleEdittype = (item) => {
        console.log(item, "itemitemitem");

        navigate('/add', {
            state: { title: "Edit Type", label: 'Edit Product Type Name', placeholder: 'Enter Type name', Editdata: item, },
        });
    };


    useEffect(() => {
        dispatch(gettype({
            endpoint: GET_type
        }));
    }, []);

    let { typedata } = useSelector((state) => state.productType);

    const handleDeletetype = (item) => {
        dispatch(deletetype({
            endpoint: DELETE_type,
            uuid: item.uuid,
        }))
            .unwrap()
            .then(() => {
                toast.success('Product Type deleted successfully!');
            })
            .catch((error) => {
                toast.error(error || 'Failed to delete the Product Type.');
            });
    };


    return (
        <main className="page-padding">
            <ToastContainer />
            <section className="product-tab-wrapper">
                <div className="container-fuild">
                    <div className="row position-relative">
                        <div className="d-flex justify-content-between align-items-center flex-wrap ">
                            <h2 className="title">All Products Type List</h2>
                            <button className="btn-grad d-inline-flex align-items-center justify-content-center text-uppercase border border-0" onClick={handleAddtypeClick}>
                                Add Product Type
                            </button>
                        </div>
                        <div className="col-12">
                            <hr />
                        </div>
                    </div>
                    <div className="col-lg-12">
                        <div className="right-tab" data-aos="fade-in" data-aos-duration="3000">
                            <div className="product-content table-responsive">
                                <table className="table table-bordered pro-table w-100">
                                    <thead>
                                        <tr>
                                            <th>sr</th>
                                            <th>Image</th>
                                            <th>Drug Dose Form</th>
                                            <th>Edit/Delete</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {typedata && typedata.length > 0 ? typedata.map((item, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>
                                                        <img src={BASE_URL +item.image} alt={item.typename} style={{ width: '50px', height: 'auto' }} />
                                                    </td>
                                                    <td>{item?.typename}</td>
                                                    <td>
                                                        <div className="d-flex">
                                                            <button className="edit-btn border border-0" onClick={() => handleEdittype(item)}>Edit</button>
                                                            <button className="delete-btn border border-0" onClick={() => handleDeletetype(item)}>Delete</button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        }) : (
                                            <tr>
                                                <td colSpan="3" className="text-center">No Product Types available</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>

    );
};

export default Producttype;